module.exports = __webpack_public_path__ + "img/nn.925a9dc1.png";